{
  "Accessibility Menu": "Menuja e Aksesueshmërisë",
  "Reset settings": "Rivendos cilësimet",
  "Close": "Mbyll",
  "Content Adjustments": "Rregullimet e Përmbajtjes",
  "Adjust Font Size": "Rregullo Madhësinë e Shkronjave",
  "Highlight Title": "Thekso Titullin",
  "Highlight Links": "Thekso Lidhjet",
  "Readable Font": "Shkronja e Lexueshme",
  "Color Adjustments": "Rregullimet e Ngjyrave",
  "Dark Contrast": "Kontrast i Errët",
  "Light Contrast": "Kontrast i Ndritshëm",
  "High Contrast": "Kontrast i Lartë",
  "High Saturation": "Ngopje e Lartë",
  "Low Saturation": "Ngopje e Ulët",
  "Monochrome": "Monokrom",
  "Tools": "Mjete",
  "Reading Guide": "Udhëzues Leximi",
  "Stop Animations": "Ndalo Animacionet",
  "Big Cursor": "Kursor i Madh",
  "Increase Font Size": "Zmadhо Shkronjat",
  "Decrease Font Size": "Zvogëlo Shkronjat",
  "Letter Spacing": "Hapësira Ndërmjet Shkronjave",
  "Line Height": "Lartësia e Rreshtit",
  "Font Weight": "Trashësia e Shkronjave",
  "Dyslexia Font": "Shkronja për Disleksinë",
  "Language": "Gjuha",
  "Open Accessibility Menu": "Hap Menynë e Aksesueshmërisë"
}
